import * as React from 'react';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { useTranslation } from 'react-i18next';
import {
  Button,
  HighlightedProfiles,
  WysiwygField,
} from '../../../components';
import { API_URL } from '../../../config/constants';
import { ProfileDefault } from '../../../types/uncinc_profile/profile';

interface DefaultProfileProps extends React.ComponentPropsWithoutRef<'div'> {
  entity: ImmutableEntity<ProfileDefault>;
}

const DefaultProfileTeaser: React.FC<DefaultProfileProps> = ({ entity, className }) => {
  const { t } = useTranslation();
  const profile = entity.toJS();

  const profileName = profile.field_full_name[0].value;
  const profileDescription = profile.field_description?.[0]?.processed;
  const profileEmail = profile.field_email_address?.[0]?.value;
  const profileFunction = profile.field_function?.[0]?.entity.name[0].value;
  const profilePictureUrl = profile.field_profile_picture?.[0]?.styles?.thumbnail;
  const profilePhoneNumber = profile.field_telephone[0]?.value;

  return (
    <div className={className}>
      <HighlightedProfiles.Profile
        picture={profilePictureUrl && (
          <img src={`${API_URL}${String(profilePictureUrl)}`} alt={t('components.default_profile_teaser.picture_alt', { name: profileName })} />
        )}
        name={profileName}
        info={profileFunction}
      />

      <WysiwygField
        className="mb-5"
        html={profileDescription}
      />

      <div className="u-multiple-buttons">
        {profileEmail && (
          <Button href={`mailto:${profileEmail}`}>{t('components.default_profile_teaser.mail')}</Button>
        )}

        {profilePhoneNumber && (
          <Button href={`tel:${profilePhoneNumber}`}>{t('components.default_profile_teaser.call')}</Button>
        )}
      </div>
    </div>
  );
};

export default DefaultProfileTeaser;
